import { useEffect, useState } from "react";
import { getTimeSince } from "../../../../utils/dateTime/library";

export type FormattedAirDateProps = {
    airDate?: number;
    ariaHidden?: boolean;
    classes?: string;
    includeSeconds?: boolean;
    isLive?: boolean;
};

export type FormatDateProps = Omit<
    FormattedAirDateProps,
    "ariaHidden" | "classes"
> & {
    formattedDate: string;
    setFormattedDate: (val: string) => void;
};
const formatDate = ({
    airDate,
    includeSeconds,
    isLive,
    formattedDate,
    setFormattedDate,
}: FormatDateProps) => {
    const newVal = getTimeSince(airDate, includeSeconds, isLive);
    if (formattedDate !== newVal) {
        setFormattedDate(newVal);
    }
};

export const FormattedAirDate = ({
    airDate,
    ariaHidden,
    classes,
    includeSeconds = false,
    isLive,
}: FormattedAirDateProps) => {
    const [formattedDate, setFormattedDate] = useState(
        getTimeSince(airDate, includeSeconds, isLive)
    );

    useEffect(() => {
        const updateInterval = setInterval(() => {
            formatDate({
                airDate,
                includeSeconds,
                isLive,
                formattedDate,
                setFormattedDate,
            });
        }, 60000);
        return () => {
            clearInterval(updateInterval);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        formatDate({
            airDate,
            includeSeconds,
            isLive,
            formattedDate,
            setFormattedDate,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [airDate]);

    return (
        <span
            className={`formattedDate ${classes || ""}`}
            aria-hidden={ariaHidden ? true : undefined}
            data-testid="formattedDate"
            suppressHydrationWarning={true}
        >
            {formattedDate}
        </span>
    );
};
